<template>
    <div class="single-course-container">
        <div class="light-header-container">
            <div class="container">
                <div class="d-flex align-center justify-space-between">
                    <div class="light-header-content">
                        <div class="light-header-breadcrumbs">
                            <v-breadcrumbs :items="items" v-if="!course.has_bought">
                                <template v-slot:divider>
                                    <v-icon>mdi-chevron-right</v-icon>
                                </template>
                            </v-breadcrumbs>
                            <v-breadcrumbs :items="useritems" v-else>
                                <template v-slot:divider>
                                    <v-icon>mdi-chevron-right</v-icon>
                                </template>
                            </v-breadcrumbs>
                        </div>
                        <div class="light-header-title d-flex align-center">
                            <template v-if="course.thumbnail">
                                <img :src="course.thumbnail" class="course-thumbnail">
                            </template>
                            <template v-else>
                                <img src="https://fakeimg.pl/350x200/?text=Sajilo Class" class="course-thumbnail">
                            </template>
                            {{course.title}}
                        </div>
                        <div class="light-header-menus">
                            <v-tabs
                            v-model="coursedesc"
                            background-color="transparent"
                            color="red"
                            >
                                <v-tab
                                    v-for="(title, i) in detailItem"
                                    :key="i"
                                >
                                    {{ title }}
                                </v-tab>
                            </v-tabs>
                        </div>
                        
                    </div>
                    <div class="light-header-btn-wrapper" v-if="course.has_bought">
                        <div class="course-progress d-flex align-center justify-space-between">
                            <v-progress-linear
                                rounded 
                                color="red darken-2"
                                :value="Math.trunc(course.complete_percentage)"
                            ></v-progress-linear>

                            <span class="course-progress__text">
                                {{course.complete_percentage ? Math.trunc(course.complete_percentage) : 0}}% complete
                            </span>
                        </div>
                        <button type="button" class="button button_red button_block button_md" @click="$router.push(`/mycourse/${$route.params.course_id}/video`), $bus.emit('loading-toggle')">Resume Course</button>
                    </div>
                </div>
                
            </div>
        </div>
       <v-container>
           <div class="single-course-main single-course sajilo-section pt-0">
               <div class="single-course-main-wrapper">
                   <v-tabs-items v-model="coursedesc">
                        <v-tab-item>
                            <!-- <div class="content-title">
                                Intro Video
                            </div> -->
                            <template v-if="course && course.content_preview_link">
                                <div class="content-description">
                                    <div class="">
                                        <vimeo-video-player :url="videoURL" class="single_vimeo_player"></vimeo-video-player>
                                        <!-- <figure class="video-banner__video-thumb">
                                        </figure> -->
                                        <!-- <button @click="dialog = true" v-if="videoURL"><v-icon>mdi-play</v-icon></button> -->
                                        <!-- <v-dialog v-model="dialog" width="auto" max-width="600">
                                            <v-card flat>
                                                <v-card-actions class="absolute">
                                                    <v-spacer></v-spacer>
                                                    <v-btn @click="dialog = false" icon small color="red">
                                                        <v-icon>mdi-close</v-icon>
                                                    </v-btn>
                                                </v-card-actions>
                                                <div class="video-wrapper">
                                                    <vimeo-video-player :url="videoURL"></vimeo-video-player>
                                                </div>
                                            </v-card>
                                        </v-dialog> -->
                                    </div>
                                </div>
                            </template>
                            <div class="content-title">
                                Short Introduction
                            </div>

                            <div class="content-description">
                                <p>{{course.description}}</p>
                            </div>

                            <div class="content-title" v-if="course.what_you_will_learn">
                                What you will learn
                            </div>

                            <div class="content-description" v-if="course.what_you_will_learn">
                                <ul>
                                    <li v-for="(item, i) in keyLearningList" :key="i">{{ item.substring(2) }}</li>
                                </ul>
                            </div>

                            <!-- <div class="content-title" v-if="course.keyword">
                                Keywords
                            </div>

                            <div class="content-description" v-if="course.keyword">
                                <ul class="d-flex single-course__keyword">
                                    <li v-for="(key, i) in course.keyword" :key="i">
                                        <button class="single-course__keyword-item">{{ key }}</button>
                                    </li>
                                </ul>
                            </div> -->
                        </v-tab-item>

                        <v-tab-item>
                            <div class="content-title">
                                Lectures Content
                            </div>

                            <div class="content-description">
                                <v-expansion-panels class="lecture">
                                    <v-expansion-panel v-for="(chapter, i) in chapterList" :key="i">
                                        <v-expansion-panel-header>
                                            <div class="title d-flex">
                                                <span>{{chapter.title}}</span>
                                                <div class="time">
                                                    <span>{{chapter.duration}}</span>
                                                    <v-icon v-if="!course.has_bought">
                                                        mdi-lock-outline
                                                    </v-icon>
                                                </div>
                                            </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p v-if="!chapter.sub_chapter.length">{{chapter.introduction}}</p>
                                            <button class="lecture__item" v-for="(sc, i) in chapter.sub_chapter" :key="i">
                                                <span>{{sc.title}}</span>
                                                <div class="time">
                                                    <span>{{sc.duration}}</span>
                                                    <v-icon v-if="!course.has_bought">
                                                        mdi-lock-outline
                                                    </v-icon>
                                                </div>
                                            </button>
                                            <!-- <button class="lecture__item">
                                                <span>0.1 : Basic Operators</span>
                                                <div class="time">
                                                    <span>1h 18m</span>
                                                    <v-icon>
                                                        mdi-lock-outline
                                                    </v-icon>
                                                </div>
                                            </button>
                                            <button class="lecture__item">
                                                <span>0.2 : Basic Operators</span>
                                                <div class="time">
                                                    <span>1h 18m</span>
                                                    <v-icon>
                                                        mdi-lock-outline
                                                    </v-icon>
                                                </div>
                                            </button> -->
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    
                                </v-expansion-panels>
                                <!-- {{ChapterList.sub_chapter}} -->
                            </div>
                        </v-tab-item>

                        <v-tab-item>
                            <div class="content-title lecturer-title">
                                {{lecturerInfo.full_name ? lecturerInfo.full_name : 'N/A'}}
                            </div>
                            <div class="content-description">
                                <p>{{lecturerInfo.lecturer_detail ? lecturerInfo.lecturer_detail.designation : 'No designation provided.'}}</p>
                            </div>
                            <div class="content-description">
                                <div class="d-flex justify-space-between">
                                    <div class="lecturer__media-group">
                                        <div class="media-group-1">
                                            <img src="@/assets/images/group-1.png" />
                                        </div>
                                        <figure class="lecturer-img">
                                            <img :src="lecturerInfo.profile_pic" v-if="lecturerInfo.profile_pic" />
                                            <img src="https://fakeimg.pl/350x200/?text=Sajilo Class" v-else />
                                        </figure>
                                    </div>
                                    <div class="lecturer__experience">
                                        <button type="button" class="trust_orange_button">
                                            <v-icon> mdi-star </v-icon>
                                            <span> {{lecturerInfo.lecturer_detail ? lecturerInfo.lecturer_detail.key_point : 'N/A'}} </span>
                                        </button>
                                        <button type="button" class="trust_purple_button">
                                            <v-icon> mdi-shape </v-icon>
                                            <span> {{lecturerInfo.lecturer_detail ? lecturerInfo.lecturer_detail.total_course : '0 courses'}} </span>
                                        </button>
                                        <button type="button" class="trust_orange_button">
                                            <v-icon> mdi-account-star </v-icon>
                                            <span> {{lecturerInfo.lecturer_detail ? lecturerInfo.lecturer_detail.total_review : '0 review'}} </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="content-description">
                                <p>{{lecturerInfo.lecturer_detail ? lecturerInfo.lecturer_detail.description : 'N/A'}}</p>
                            </div>
                        </v-tab-item>
                    </v-tabs-items>
               </div>
               <div class="single-course-sidebar">
                   <div class="single-course-sidebar-wrapper"  v-if="!course.has_bought && course.package">
                       <v-tabs class="package-tab" v-model="package_tab">
                            <v-tab v-for="(pkgs, i) in course.package" :key="i" @click="packageStat = !packageStat">
                                <div class="single-course-sidebar-price">
                                    <span v-if="course.package ">Rs. {{Math.trunc(pkgs.discounted_price)}}</span>
                                </div>
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="package_tab" class="package-tab-item" style="background-color: transparent">
                            <v-tab-item v-for="(pkg, i) in course.package" :key="i">
                                <div class="single-course-sidebar-content">
                                    <div class="sidbear-content-left">
                                        Price
                                    </div>
                                    <div class="sidbear-content-right">
                                        <span style="text-decoration: line-through">Rs {{Math.trunc(pkg.price)}}</span>
                                    </div>
                                </div>
                                <div class="single-course-sidebar-content">
                                    <div class="sidbear-content-left">
                                        Discounted Price
                                    </div>
                                    <div class="sidbear-content-right">
                                        <span>Rs {{Math.trunc(pkg.discounted_price)}}</span>
                                    </div>
                                </div>
                                <div class="single-course-sidebar-content">
                                    <div class="sidbear-content-right">
                                        <span>{{pkg.description}}</span>
                                    </div>
                                </div>
                                <div class="single-course-sidebar-content">
                                    <div class="sidbear-content-left">
                                        Valid Till
                                    </div>
                                    <div class="sidbear-content-right">
                                        <span>{{pkg.validity}} Days</span>
                                    </div>
                                </div>
                                <div class="single-course-sidebar-btn" v-if="!course.has_bought && course.package">
                                    <v-btn
                                        type="button" class="big_blue_button" 
                                        v-if="!boughtcourse" 
                                        :loading="loading"
                                        :disabled="loading"
                                        @click.prevent="buyCourse(pkg.id)"
                                    >
                                        Buy With Fonepay
                                        <template v-slot:loader>
                                            <span>Loading...</span>
                                        </template>
                                    </v-btn>
                                    <a :href="boughtcourse.transaction_link" target="_blank" v-if="boughtcourse && packageStat === false">
                                        <button type="button" class="big_blue_button red white--text">Payment with Fonepay</button>
                                    </a>
                                    <v-btn
                                        type="button" class="big_blue_button mt-2"
                                        v-if="!boughtcourse2"
                                        :loading="loading2"
                                        :disabled="loading2"
                                        @click.prevent="buyEsewa(pkg.id)"
                                    >
                                        Buy With Esewa
                                        <template v-slot:loader>
                                            <span>Loading...</span>
                                        </template>
                                    </v-btn>
                                    <button type="button" @click.prevent="esewaLink()" v-if="boughtcourse2 && packageStat === false">
                                        <button type="button" class="big_blue_button red white--text mt-2" style="width: 100%;">Payment with Esewa</button>
                                    </button>
                                </div>
                                
                            </v-tab-item>
                        </v-tabs-items>
                        <div>
                            <span class="icon-zigzag-line"></span>
                        </div>
                   </div>
                   <div class="single-course-sidebar-wrapper">
                      
                        <div class="single-course-sidebar-content">
                            <div class="sidebar-content-left">
                                Lecturer
                            </div>
                            <div class="sidebar-content-right">
                                {{lecturerInfo.full_name ? lecturerInfo.full_name : 'N/A'}}
                            </div>
                        </div>
                        <div class="single-course-sidebar-content">
                            <div class="sidebar-content-left">
                                Posted on
                            </div>
                            <div class="sidebar-content-right">
                                {{course.datetime_created}}
                            </div>
                        </div>
                        <div class="single-course-sidebar-content">
                            <div class="sidebar-content-left">
                                Enrolled Students
                            </div>
                            <div class="sidebar-content-right">
                                {{ course.enrolled_student }}
                            </div>
                        </div>
                        <div class="single-course-sidebar-content">
                            <div class="sidebar-content-left">
                                Language
                            </div>
                            <div class="sidebar-content-right">
                                {{course.language}}
                            </div>
                        </div>
                        <div class="single-course-sidebar-content">
                            <div class="sidebar-content-left">
                                Lectures
                            </div>
                            <div class="sidebar-content-right">
                                {{course.lectures_count}}
                            </div>
                        </div>
                        
                        <div>
                            <span class="icon-zigzag-line"></span>
                        </div>
                   </div>
               </div>
           </div>
       </v-container>
       <v-dialog v-model="buydialog" width="100%" max-width="500" persistent>
           <v-card flat class="px-5 py-5">
               <v-card-title class="pl-2 pt-0">
                   You are not login yet. Please login to your <br> account or create new account.
               </v-card-title>
               <v-card-actions>
                    <v-btn class="primary-btn btn-lg" @click="$router.push('/login')">Log In</v-btn>
                    <v-btn class="primary-btn btn-lg" @click="$router.push('/register')">Register</v-btn>
                    <v-btn class="red-btn btn-lg" @click="buydialog = false">Close</v-btn>
               </v-card-actions>
           </v-card>
       </v-dialog>
       <!-- <esewa-form :esewaData="boughtcourse2"></esewa-form> -->
       <form :action="formAction" v-if="boughtcourse2" method="POST" ref="esewaForm">
        <input :value=boughtcourse2.data.tAmt name="tAmt" type="hidden">
        <input :value=boughtcourse2.data.amt name="amt" type="hidden">
        <input :value=boughtcourse2.data.txAmt name="txAmt" type="hidden">
        <input :value=boughtcourse2.data.psc name="psc" type="hidden">
        <input :value=boughtcourse2.data.pdc name="pdc" type="hidden">
        <input :value=boughtcourse2.data.scd name="scd" type="hidden">
        <input :value=boughtcourse2.data.pid name="pid" type="hidden">
        <input :value=boughtcourse2.data.su type="hidden" name="su">
        <input :value=boughtcourse2.data.fu type="hidden" name="fu">
    </form>
    </div>
</template>

<script>
import VimeoVideoPlayer from '../vimeo/vimeo'
// import EsewaForm from './EsewaForm.vue'
  export default {
    data: () => ({
        course: {},
        items: [
            {
            text: 'Home',
            disabled: false,
            href: '/',
            },
            {
            text: 'Programming',
            disabled: false,
            href: `#`,
            },
            {
            text: 'Python Course for All Beginners by Carl Baristonsy',
            disabled: true,
            href: '#',
            }
        ],
        useritems: [
            {
            text: 'My Courses',
            disabled: false,
            href: '/mycourses',
            },
            {
            text: 'Python Course for All Beginners by Carl Baristonsy',
            disabled: true,
            href: '#',
            }
        ],
        coursedesc: null,
        detailItem: [
            'Description', 'Lectures', 'Lecturer',
        ],
        keywords: [
            'Python', 'Django', 'Carl Baristonsy', 'Full Tutorial', 'Books', 'Beginner Course', 'Programming', 'Cheap', 'Python Full Course'
        ],
        videoURL: '',
        keyLearningList: [],
        lecturerInfo: [],
        chapterList: [],
        dialog: false,
        // chId: '',
        subChapterList: [],
        user: JSON.parse(localStorage.getItem('user')),
        boughtcourse: '',
        boughtcourse2: '',
        bcourse: {
            package: '',
        },
        buydialog: false,
        loader: null,
        loading: false,
        loading2: false,
        package_tab: null,
        packageStat: false,
        formAction: 'https://uat.esewa.com.np/epay/main'
    }),
    components: {
        VimeoVideoPlayer, 
        // EsewaForm
    },
    
    methods: {

        async getCourse() {
            
            this.$bus.emit('loading-toggle');
            await this.$api.get(`course/course/`+this.$route.params.course_id).then(res => {
                this.course = res;
                if (res.what_you_will_learn !== null) {
                    this.keyLearningList = res.what_you_will_learn.split("\n");
                }
                this.items[2].text = res.title;
                this.items[1].href = `/course/?category=${res.category.id}&categoryName=${res.category.name}`
                this.items[1].text = res.category.name
                this.useritems[1].text = res.title;
                this.lecturerInfo = res.lecturer;
                this.course.datetime_created = res.datetime_created.substring(10, '');
                if(res.content_preview_link) {
                //     this.course.content_preview_link = res.content_preview_link.split('&ab_channel');
                //     this.course.content_preview_link = this.course.content_preview_link[0].split('watch?v=');
                //     this.videoURL= this.course.content_preview_link[0]+'embed/'+this.course.content_preview_link[1];
                    // this.videoURL= this.course.content_preview_link;
                    this.videoURL= res.content_preview_link;
                }
                this.getChapterList();
                if(res.package) {
                    this.course.package = res.package;
                }
                else {
                    this.course.package = null;
                }
            })
            
                this.$bus.emit('loading-toggle');
        },
        afterFonePay() {
            window.location.reload();
        },
        async getLecturesData(id) {
            let url = 'course/chapter-list/'+id;
            await this.$api.get(url).then(res => {
                this.chapterList = res;  
                // for(let i=0; i < res.length; i++) {
                //     console.log(res[i])
                // }
                
            })
        },

        // async getSubChapter(id) {
        //     let url = 'http://onlinecourse.susankya.com.np/api/course/subchapter-list/'+id;
        //     let res = await this.$api.get(url);
        //     this.subChapterList = res;  
        // },

        getChapterList() {
            let courseId = this.course.id;
            this.getLecturesData(courseId);
        },

        // getChapterId(i) {
        //     this.chId = this.chapterList[i].id;
        //     this.getSubChapter(this.chId);
        // },

        async buyCourse(id) {
            if(this.course.package && this.user) {
                this.bcourse.package = id;
                // this.$bus.emit('loading-toggle');
                this.loader = 'loading'
                await this.$api.post(`/subscription/initiate-transaction/`, this.bcourse).then(res => {
                    this.boughtcourse = res;
                }).catch((err) => {
                    condole.log(err);
                })
                
                // this.$bus.emit('loading-toggle');
            }
            else {
                this.buydialog = true;

            }
        },

        async buyEsewa(id) {
            if(this.course.package && this.user) {
                this.bcourse.package = id;
                this.bcourse.provider = 'web esewa'
                // this.$bus.emit('loading-toggle');
                this.loader = 'loading2'
                await this.$api.post(`/subscription/esewa-transaction/`, this.bcourse).then(res => {
                    this.boughtcourse2 = {
                        path: res.esewa_link,
                        data: {
                            amt: res.data.amount,
                            psc: '0',
                            pdc: '0',
                            txAmt: '0',
                            tAmt: res.data.amount,
                            pid: res.data.prn,
                            scd: res.SCD,
                            su: res.ru,
                            fu: res.ru
                        }
                    }
                    console.log(this.boughtcourse2.data)
                }).catch((err) => {
                    condole.log(err);
                })
                
                // this.$bus.emit('loading-toggle');
            }
            else {
                this.buydialog = true;

            }
        },

        esewaLink() {
            // this.$bus.emit('submit-esewa-form');
            if(this.formAction) {
                this.$refs.esewaForm.submit();
            }
        }

    },

    
    mounted () {
        this.getCourse();
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    },
  }
</script>

<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>